export const SET_API_KEYS = 'SET_API_KEYS';
export const CLEAR_API_KEYS = 'CLEAR_API_KEYS';
export const SET_CREATED_API_KEY = 'SET_CREATED_API_KEY';
export const CLEAR_CREATED_API_KEY = 'CLEAR_CREATED_API_KEY';
